import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { InfoOutlineIcon, PrimaryButton } from 'ia-react-core';
import { FormPageTitle, redirectTo, ResourcesLoader } from 'omni-package-react-core';
import { StyledActionBar, StyledBlock, StyledP, StyledAside, StyledIconDiv } from './PersonalInformationsIntroductionPage.styles';
import SubsidiariesResource from './SubsidiariesResource/SubsidiariesResource';
import SubsidiaryLinks from './SubsidiariesResource/SubsidiaryLinks';
import Constants from '../../Constants';

export interface PersonalInformationsIntroductionPageProps { }

const PersonalInformationsIntroductionPage: FC<PersonalInformationsIntroductionPageProps> = () => {
  const { t } = useTranslation('PersonalInformationsIntroductionPage');

  const navigate = useNavigate();

  return (
    <ResourcesLoader>
      <ResourcesLoader.Resources>
        <SubsidiariesResource
          autoRequestIfEmpty
          requestOnLanguageChange
        />
      </ResourcesLoader.Resources>
      <ResourcesLoader.Content>
        <FormPageTitle>{t('title')}</FormPageTitle>
        <StyledBlock white>
          <StyledAside>
            <StyledIconDiv>
              <InfoOutlineIcon width={48} height={48} />
            </StyledIconDiv>
            <div>
              <StyledP>{t('warningTopText')}</StyledP>
              <SubsidiaryLinks />
            </div>
          </StyledAside>
        </StyledBlock>
        <StyledActionBar flexButtons>
          <PrimaryButton
            onClick={() => {
              redirectTo(Constants.PersonalInformationsFormPagePath, navigate);
            }}
          >
            {t('continueButton')}
          </PrimaryButton>
        </StyledActionBar>
      </ResourcesLoader.Content>
    </ResourcesLoader>

  );
};
export default PersonalInformationsIntroductionPage;
